export default __webpack_public_path__ + "static/media/12.b0fd8956.png";